import { usePaginatedSearch } from '../usePaginatedSearch';
import { getProviders } from '@/services/api/requests/providers';
import queryKeys from '@/constants/queryKeys';
import { TProviderApi, TProviderFilterOption } from '@/types/Provider.types';

const useProviders = ({
  filterOption,
  filterText,
  status,
}: {
  filterOption?: TProviderFilterOption;
  filterText: string;
  status: 'active' | 'inactive';
}) => {
  return usePaginatedSearch<TProviderApi[], TProviderFilterOption, string>({
    query: (page, searchFilterType, searchFilterText) => getProviders(page, searchFilterType, searchFilterText, status),
    queryKey: [queryKeys.providers.all, status],
    searchFilterType: filterOption ?? 'Name',
    searchFilterText: filterText,
  });
};

export default useProviders;
